import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ORANGE } from '../components/itineraryUtils';

interface ItineraryMoreMenuProps {
  visible: boolean;
  onClose: () => void;
  onSettings: () => void;
  onChangeCover: () => void;
  isOwner: boolean;
  allowTeamEdit: boolean;
  onToggleTeamEdit: (value: boolean) => void;
  isInEditMode: boolean;
  onToggleEditMode: () => void;
}

const ItineraryMoreMenu: React.FC<ItineraryMoreMenuProps> = ({
  visible,
  onClose,
  onSettings,
  onChangeCover,
  isOwner,
  allowTeamEdit,
  onToggleTeamEdit,
  isInEditMode,
  onToggleEditMode,
}) => {
  if (!visible) return null;

  return (
    <View style={styles.menuContainer}>
      <TouchableOpacity 
        style={styles.menuItem}
        onPress={() => {
          onClose();
          onSettings();
        }}
      >
        <Text style={styles.menuText}>行程設置</Text>
      </TouchableOpacity>
      
      <TouchableOpacity 
        style={styles.menuItem}
        onPress={() => {
          onClose();
          onChangeCover();
        }}
      >
        <Text style={styles.menuText}>更換封面</Text>
      </TouchableOpacity>
      
      {isOwner && (
        <View style={styles.menuItem}>
          <Text style={[styles.menuText, { marginBottom: 12 }]}>團隊編輯</Text>
          <TouchableOpacity 
            style={styles.switchRow}
            onPress={() => onToggleTeamEdit(!allowTeamEdit)}
            activeOpacity={0.8}
          >
            <View style={[
              styles.switchTrack,
              { backgroundColor: allowTeamEdit ? ORANGE : '#D1D5DB' }
            ]}>
              <View style={[
                styles.switchThumb,
                { alignSelf: allowTeamEdit ? 'flex-end' : 'flex-start' }
              ]} />
            </View>
          </TouchableOpacity>
        </View>
      )}
      
      <TouchableOpacity 
        style={[styles.menuItem, { borderBottomWidth: 0 }]}
        onPress={() => {
          onClose();
          onToggleEditMode();
        }}
      >
        <Text style={styles.menuText}>
          {isInEditMode ? '預覽模式' : '編輯模式'}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  menuContainer: {
    position: 'absolute',
    top: 50,
    right: 0,
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    zIndex: 9999,
    // minWidth removed or reduced to fit content better
  },
  menuItem: {
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  menuText: {
    fontSize: 16,
    color: '#333',
  },
  switchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start', // Changed to start since label is gone
  },
  switchLabel: {
    fontSize: 14,
    color: '#666',
  },
  switchTrack: {
    width: 64, // Increased to match text width (approx 4 chars * 16px)
    height: 24, // Slightly taller
    borderRadius: 12, 
    justifyContent: 'center',
    padding: 2,
  },
  switchThumb: {
    width: 20, 
    height: 20, 
    borderRadius: 10, 
    backgroundColor: '#fff',
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  }
});

export default ItineraryMoreMenu;
